
				var addMethods = require("../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["FinderGoal","testVariation","prepareRefinedConfig","prepareAttackSearch","createArmyConfig","prepareSearch","searchSingleBlock"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "88f4143c14426e7384de.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			